module.exports = __webpack_public_path__ + "img/resolute.4c96a5f1.jpg";